import EFOcats_answer from './efocats_answer.js';

/**
 * elem.find(".container").hasClass("required")の時の回答欄設置処理
 */
export default class EFOcats_answer_require extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    if (elem.find('.container').hasClass('required')) {
      elem.find('.check-flag').addClass('required');
      elem.find('.ok-flag').removeClass('required');
    } else {
      elem.find('.check-flag').addClass('ok-flag');
    }
  }
}
